import posthog from 'posthog-js';

const POSTHOG_KEY = 'phc_x8bv8xutsNzS0y8w95KsS4q9nhhgnMIwV8dJxOsHuPv';
const POSTHOG_HOST = 'https://t.hireveda.com';

/** Vite production build (`vite build`). Local `vite` / `npm run dev` stays off. */
export const isProd = import.meta.env.PROD;

export const isPosthogEnabled = isProd;

export { POSTHOG_KEY };
export const posthogOptions = {
  api_host: POSTHOG_HOST,
  defaults: '2026-05-30',
  // PageTracker captures route changes; leave automatic pageviews off.
  capture_pageview: false,
  persistence: 'localStorage+cookie',
};

if (isPosthogEnabled) {
  posthog.init(POSTHOG_KEY, posthogOptions);
  console.info('[posthog] enabled', { host: POSTHOG_HOST });
}

export function identifyUser(user) {
  if (!isPosthogEnabled || !user?.id) return;
  posthog.identify(user.id, {
    email: user.email,
    name: user.name,
    role: user.role,
  });
}

export function resetPosthog() {
  if (!isPosthogEnabled) return;
  posthog.reset();
}

export function capturePageview(pathname) {
  if (!isPosthogEnabled) return;
  posthog.capture('$pageview', {
    $current_url: window.location.href,
    pathname,
  });
}

export default posthog;
